<template>
    <div class="appWrapper" v-click-outside="hide" @click="toggle">
        <img alt="Badge" src="../assets/badge.png"/>
        <div class="activeStatus">
            <span v-if="activeStatus !== null" :style="{ background : activeStatus.color }">
                {{ activeStatus.title }}
            </span>
                <span style="background: #47c1bf;" v-else>No status Selected</span>
        </div>
        <div class="statusesWrap">
            <draggable
                    class="list-group"
                    tag="div"
                    v-model="statuses"
                    v-bind="dragOptions"
                    @start="drag = true"
                    @end="drag = false"
                    v-show="opened"
            >
                <transition-group type="transition">
                    <div v-if="statuses.length > 0" v-for="status in statuses"
                         class="option"
                         :class="{'active' : (activeStatus != undefined && parseInt(status.id) == activeStatus.id) }"
                         :key="status.order"
                         @click="changeActiveStatus(status)"
                    >
                        <span class="colorCircle" :style="{ background : status.color }"></span>
                        <span class="title">{{ status.title }}</span>
                    </div>
                </transition-group>
            </draggable>
        </div>
    </div>
</template>
<script>

    import axios from "axios";
    import draggable from "vuedraggable";
    import ClickOutside from 'vue-click-outside'

    export default {
        name: "Statuses",
        display: "Transitions",
        components: {
            draggable
        },
        directives: {
            ClickOutside
        },
        data: function () {
            return {
                drag: false,
                opened: false
            }
        },
        computed: {
            statuses: {
                get: function () {
                   return this.$store.state.statuses;
                },
                set: function (newOrder) {
                    this.$store.commit('fillStatuses', newOrder);
                }
            },
            showStatuses () {
                return this.$store.state.showStatuses;
            },
            activeStatus () {
                return this.$store.state.activeStatus;
            },
            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            }
        },
        methods: {
            changeActiveStatus (status) {
                this.$store.commit('changeActiveStatus', status);
            },
            sort() {
                this.statuses = this.statuses.sort((a, b) => a.order - b.order);
            },
            toggle () {
                if (this.opened == false) {
                    this.opened = true;
                } else if (this.opened == true) {
                    this.opened = false;
                }
            },
            hide () {
                this.opened = false
            }
        },
    };
</script>

<style scoped lang="less">

    .activeStatus span {
        display: inline-block;
        border-radius: 4px;
        padding: 2px 4px;
        color: #fff;
        font-size: 12px;
        cursor: pointer;
    }

    .statusesWrap {
        position: absolute;
        top: 100%;
        left: 75px;
        background: #fff;
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        max-height: calc(100vh - 40px);
        overflow: hidden;
        overflow-y: auto;
        border-radius: 10px;
        text-align: left;
        padding: 10px 0;

        .list-group {
            margin: 0;
        }

        .option {
            border-left: 2px solid #fff;
            background: #fff;
            padding: 9px 25px 9px 15px;
            font-size: 12px;
            color: #000;
            font-weight: 300;
            transition: background-color 0.5s, border-color 0.5s;
            cursor: pointer;
            white-space: nowrap;

            &:hover {
                background: #f7f9fd;
                border-color: #f7f9fd;
            }

            &.active {
                font-weight: 700;
                background: #ebf5fa;
                border-color: #0085e0;
                color: #043159;
            }

            span {
                display: inline-block;
                vertical-align: middle;
            }

            .colorCircle {
                border: 2px solid #fff;
                border-radius: 100%;
                width: 10px;
                height: 10px;
                background: #000;
                margin-right: 10px;
            }
        }

    }
    img {
        cursor: pointer;
    }
    .active-item {
        background-color: red;
    }

</style>


